import React from "react";
import classNames from "classnames";
import Dialog from "rc-dialog";
import "rc-dialog/assets/bootstrap.css";

export default class ChapterProgress extends React.Component {
    constructor(props) {
        super(props);

        this.showWarning = this.showWarning.bind(this);
        this.hideWarning = this.hideWarning.bind(this);
        this.continueClick = this.continueClick.bind(this);

        this.state = {
            showDialog: false,
            link: ""
        };
    }

    showWarning(link) {
        if (this.props.isDirty) {
            this.setState({
                showDialog: true,
                link: link
            });
        } else {
            this.props.router.push(link);
        }
    }

    hideWarning() {
        this.setState({
            showDialog: false
        });
    }

    continueClick() {
        this.hideWarning();
        this.props.router.push(this.state.link);
    }

    render() {
        let chapters = this.props.chapters;
        let activeChapter = this.props.activeChapter;
        let chapterRows = [];

        let dialog = (
            <Dialog
                title="Weet je het zeker?"
                onClose={this.hideWarning}
                visible={this.state.showDialog}
                animation="fade"
                footer={[
                    <button type="button" className="btn btn-light" key="no" onClick={this.hideWarning}>
                        Nee, ik moet nog opslaan
                    </button>,
                    <button type="button" className="btn btn-primary" key="yes" onClick={this.continueClick}>
                        Ja, ik wil doorgaan
                    </button>
                ]}
            >
                <p>Wil je dit opslaan of wil je hier weg?</p>
            </Dialog>
        );

        let i = 1;
        chapters.forEach((chapter) => {
            let className = classNames("chapter-item", { current: i == this.props.activeChapter }, { active: i < this.props.activeChapter });

            if (chapter.link === false) {
                chapterRows.push(
                    <div key={i} className={className}>
                        {chapter.title}
                    </div>
                );
            } else {
                chapterRows.push(
                    <div key={i} className={className} onClick={() => this.showWarning(chapter.link)}>
                        {chapter.title}
                    </div>
                );
            }
            i++;
        });

        return (
            <div className="chapter-progress">
                {chapterRows}
                {dialog}
            </div>
        );
    }
}
